<template>
  <div>
    <h2 class="font-weight-light">Billing Information</h2>

    <span>
    <v-skeleton-loader type="card" v-if="progress"></v-skeleton-loader>
    <div class="card rounded-xl" :class="$vuetify.theme.isDark ? 'bg-dark' : ''" v-if="!progress && card">

      <div class="card-body">
        <v-row>
          <v-col cols="6">
            <img
                :src="'/img/icons/'+card.brand+'.png'"
                width="40px"
            >
          </v-col>

          <v-col cols="6" class="text-right">
            <strong>
              {{ card.country_code }}
            </strong><br>

            <small>Country</small>
          </v-col>


        </v-row>


        <v-row>
          <v-col class="text-center">
            <h2 class="font-weight-bold" style="letter-spacing: 6px;">
              {{ card.bin }} ****** {{ card.last4 }}
            </h2>

          </v-col>


        </v-row>
        <v-row>
          <v-col cols="8">
            <strong>{{ card.bank }}</strong><br>
            <small>Issued By</small>

          </v-col>

          <v-col cols="4" class="text-right">
            <strong>{{ card.exp_month }}/{{ card.exp_year }}</strong><br>
            <small>Expires On</small>
          </v-col>

        </v-row>
      </div>
    </div>
    <v-row dense v-if="customer">
      <v-col cols="12">

        <v-timeline size="10" dense>
          <v-timeline-item
              dense
              color="grey"
              small
              class="pa-0"
          >
            <v-list-item dense class="pa-0 ma-0 border-bottom">
              <v-list-item-content class="pa-0 ma-0">
                <v-list-item-title class=" text-h6 font-weight-light">
                  {{ customer.last_name }}
                </v-list-item-title>
                <v-list-item-subtitle><small>Name</small></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-timeline-item>

          <v-timeline-item
              dense
              color="grey"
              small
              class="mt-3"

          >
            <v-list-item dense class="pa-0 border-bottom">
              <v-list-item-content class="pa-0 ma-0">
                <v-list-item-title class="text-h6 font-weight-light">
                  {{ customer.email }}
                </v-list-item-title>
                <v-list-item-subtitle><small>Email</small></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-timeline-item>


          <v-timeline-item
              dense
              color="grey"
              small
              class="mt-3"

          >
            <v-list-item dense class="pa-0 ">
              <v-list-item-content class="pa-0 ma-0">
                <v-list-item-title class="text-h6 font-weight-light">
                  {{ customer.created_at | humanDateTime }}
                </v-list-item-title>
                <v-list-item-subtitle><small>Created At</small></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-timeline-item>


        </v-timeline>

        <v-subheader>Subscriptions</v-subheader>
        <v-card
            v-for="(sub,index) in customer.subscriptions"
            v-if="customer.subscriptions"
            :key="index"
            flat
            :class="{
              'border-b':index<customer.subscriptions.length
            }"
        >
          <v-card-text>
            <v-list-item>

              <v-list-item-content class="pa-0 ma-0">
                <v-list-item-title class="text-h6 font-weight-light">
                  {{ (sub.amount / 100) }}
                </v-list-item-title>
                <v-list-item-subtitle>Amount</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-text>
                <v-chip dark text
                        class="lighten-5"
                        :class="{
                  'green green--text':sub.status=='active',
                  'red':sub.status!='active'

                }">{{ sub.status }}
                </v-chip>
              </v-list-item-text>
            </v-list-item>


            <v-list-item class="mt-3">

              <v-list-item-content class="pa-0 ma-0">
                <v-list-item-title class="text-h6">
                  {{ sub.next_payment_date | humanDateTime }}
                </v-list-item-title>
                <v-list-item-subtitle>Next Subscription Date</v-list-item-subtitle>
              </v-list-item-content>


            </v-list-item>

          </v-card-text>
          <v-card-actions>
            <v-btn
                :loading="loading"
                depressed
                rounded
                block
                large
                text
                color="blue"
                dark
                @click="getLink(sub.subscription_code)"
            >Manage Subscription <sup><v-icon color="blue" x-small>mdi-open-in-new</v-icon></sup>
            </v-btn>
          </v-card-actions>
        </v-card>

      </v-col>
    </v-row>
    <center v-if="!card">
      <small class="text-muted">
        Your billing card would show here
      </small>
    </center>
    </span>

    <stripe-customer v-if="business.stripe_id"></stripe-customer>

    <!--    <center>-->
    <!--      <small class="text-muted">To change your billing card, manually subscribe with a new card </small>-->
    <!--    </center>-->
  </div>
</template>

<script>
import StripeCustomer from "@/components/patials/StripeCustomer.vue";

export default {
  name: "billingCard",
  components: {StripeCustomer},
  data() {
    return {
      customer: null,
      progress: false,
      loading: false

    }
  },
  computed: {
    card() {
      return this.customer?.authorizations?.length > 0 ? this.customer.authorizations[0] : null;
    },
    business() {

      return this.$store.state.user.user_infor.current_business;

    }
  },
  methods: {

    getLink(code) {

      this.loading = true;
      const URL = "/api/paystack/manage-link/" + code;

      axios.get(URL)
          .then(res => {
            window.open(res.data.data.link);
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;

          })

    },
    getCard() {
      this.progress = true;
      axios.get('/api/paystack/customer')
          .then(res => {
            this.customer = res.data.data;
            this.progress = false;
          })
    }
  },
  mounted() {
    this.getCard();
  }
}
</script>

<style scoped>

</style>